import React, { useState, useEffect, useRef } from 'react';

import MainComp from './MainComp';

import Login from './pages/Auth/Login';


import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import './assets/demo/flags/flags.css';
import './assets/demo/Demos.scss';
import './assets/layout/layout.scss';
import './App.scss';

const App = () => {

    const [isLoggedIn, setAuth] = useState(localStorage.getItem("auth"));

    useEffect(() => {
        setAuth(localStorage.getItem("auth") == null ? false : localStorage.getItem("auth"));
    }, []);


    return (
        <>


            {!isLoggedIn ? <Login /> : <MainComp />}


        </>
    )

}

export default App;
